module.exports = __webpack_public_path__ + "static/media/Artboard9.66d103bc.png";